// extracted by mini-css-extract-plugin
module.exports = {"main_black":"#23335B","profile__form-container":"style_profile__form-container__3MDIg"};